export const userData = [
  {
    status: true,
    msg: "Success",
    transhistory: [
      {
        name: "Raj Kumar",
        account: 9876543210,
        accountType: "Current",
        balance: 15000.55,
        withdrawable: 15000.55,
        currency: "INR",
        uncleared: 0.0,
        amb: 15000.55,
      },
      {
        name: "Jaideep",
        account: 1234567890,
        accountType: "Savings",
        balance: 25000.75,
        withdrawable: 25000.75,
        currency: "EUR",
        uncleared: 0.0,
        amb: 25000.75,
      },
      {
        name: "Sheespal",
        account: 1122334455,
        accountType: "Fixed Deposit",
        balance: 50000.0,
        withdrawable: 50000.0,
        currency: "GBP",
        uncleared: 0.0,
        amb: 50000.0,
      },
    ],
  },
];
